/**
 * Composable for converting one type to another type. You can add customized rule here as well
 */
import moment from 'moment';
export default function () {
  /**
   * Transform an object of type any into a boolean true/false. Evaluations include data such as 1, "true" being returned as true, etc.
   * Passing a boolean parameter will just return itself
   *
   * @param otherType object of any type
   * @param defaultVal if the type is not supported, this value will be returned instead
   * @returns true|false
   */
  function toBool(otherType: any, defaultVal = true) {
    if (typeof otherType === 'string') {
      return otherType == null ||
        otherType == undefined ||
        otherType == '' ||
        otherType == '0' ||
        otherType.toLowerCase() == 'false'
        ? false
        : true;
    } else if (typeof otherType === 'number') {
      return otherType > 0;
    } else if (typeof otherType === 'boolean') {
      return otherType;
    } else if (otherType == null) {
      return false;
    }
    return defaultVal;
  }

  function toArray(otherType: any) {
    if (otherType == undefined || otherType == null) return [];
    if (Array.isArray(otherType)) return otherType;
    return Array.of(otherType);
  }

  function bytesToHumanReadable(bytes: number, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  // convert UTC to local time (DB saves UTC dates)
  function UTCtoLocalTime(utcTime: any) {
    return moment.utc(utcTime).local().format();
  }
  function formattedDate(value: any, dateOnly = false, monthOnly = false) {
    moment.locale('de');
    if (value) {
      if (dateOnly) {
        return moment(String(value)).format('DD.MM.YYYY');
      } else if (monthOnly) {
        return moment(String(value)).format('MMM YYYY');
      } else {
        const dateString = moment(String(value)).format('DD.MM.YYYY');
        const timeString = moment(String(value)).format('HH:mm');
        return dateString + ' um ' + timeString + ' Uhr';
      }
    }
  }

  return {
    toBool,
    toArray,
    bytesToHumanReadable,
    formattedDate,
    UTCtoLocalTime,
  };
}
